import { getRgObjectsOfType as l, RG_TYPE as o } from "@project-rouge/rg-core";
import { getLevelFacadeExternalCornerLength as a } from "../level-metrics/index16.js";
const s = (n) => {
  let e = 0;
  const r = l(n, o.Building);
  for (const t of r)
    e += g(t);
  return e;
};
function g(n) {
  let e = 0;
  const r = new Set(n.data.levels.map((t) => t.levelIndex));
  for (const t of r)
    e += a(n, t);
  return e;
}
export {
  s as getFacadeExternalCornerLength
};
//# sourceMappingURL=index18.js.map
